import React, { useState, useEffect } from 'react'
import { getAllGenieChats, AllGenieChats } from '../api/client'
import { useNotify } from '../components/notice/useNotify'
import GenieChatList from '../components/GenieChatList'
import Spinner from '../components/Spinner'

const GenieHistory: React.FC = () => {
  const notify = useNotify()
  
  const [allChats, setAllChats] = useState<AllGenieChats>({
    chats: []
  })
  const [loading, setLoading] = useState(true)
  
  const fetchAllChats = async () => {
    setLoading(true)
    try {
      // Stage 5: advice chats now live in `genie_chats` too. Filter to
      // agent-kind so the Genie history page doesn't surface advice chats —
      // those have their own index page at /advice.
      const response = await getAllGenieChats('agent')
      setAllChats(response)
    } catch (err) {
      notify.error('Failed to load genie chats')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAllChats()
  }, [])
  
  if (loading) {
    return (
      <div className="flex flex-col min-h-screen bg-blush-light">
        <div className="container mx-auto px-4 pb-8 sm:pt-8 flex justify-center items-center flex-grow">
            <Spinner />
        </div>
      </div>
    )
  }
  
  return (
    <div className="flex flex-col min-h-screen bg-blush-light">
      <div className="container mx-auto px-4 pb-8 sm:pt-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            Past Genie Chats
          </h1>
          <p className="text-gray-600 mt-2">Did you need something discussed earlier?</p>
        </div>
        
          <GenieChatList
            chats={allChats.chats}
            emptyMessage="No genie conversations yet."
            emptySubMessage="Start a chat to create projects and features with AI assistance."
            onChatDeleted={fetchAllChats}
          />
      </div>
    </div>
  )
}

export default GenieHistory